export default function PortalSessionLoader({ label = 'Checking your session…' }) {
  return <div className="portal-spinner" role="status" aria-label={label} />;
}
